import { useCan } from '../store';
import { Resource } from '../api/authz';

/**
 * 维护视角判定 (2026-09-13): 对某资源有任一写权 = 维护者, 否则是只读访问者。
 *
 * 只读访问者只看"在用"的数据 —— 停用 / 未上线的条目是维护过程态, 对他们没有意义,
 * 展示出来反而会被当成可选项 (如已停用的字典值仍出现在列表里)。
 * 各列表据此过滤行, 同时隐藏「操作」列与状态开关。
 */
export function useIsMaintainer(resource: Resource): boolean {
    const canCreate = useCan(resource, 'create');
    const canUpdate = useCan(resource, 'update');
    const canDelete = useCan(resource, 'delete');
    return canCreate || canUpdate || canDelete;
}
